import React from 'react';

interface VideoEmbedProps {
  url: string;
  className?: string;
}

const VideoEmbed: React.FC<VideoEmbedProps> = ({ url, className = '' }) => {
  // Function to extract YouTube video ID
  const getYouTubeVideoId = (url: string): string | null => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // Function to extract TikTok video ID
  const getTikTokVideoId = (url: string): string | null => {
    const regExp = /^.*(?:tiktok.com\/)(?:\w+\/)?(?:v\/)?(\d+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  if (!url) {
    return null;
  }

  // Handle YouTube videos
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const videoId = getYouTubeVideoId(url);
    if (!videoId) return null;

    return (
      <div className={`relative w-full ${className}`} style={{ paddingTop: '56.25%' }}>
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  // Handle TikTok videos
  if (url.includes('tiktok.com')) {
    const videoId = getTikTokVideoId(url);
    if (!videoId) return null;

    return (
      <div className={`relative w-full ${className}`} style={{ paddingTop: '177.77%' }}>
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src={`https://www.tiktok.com/embed/${videoId}`}
          title="TikTok video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return null;
};

export default VideoEmbed;
